import { render } from "./EmployeeDetail.vue?vue&type=template&id=7b78cfce"
import script from "./EmployeeDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeDetail.vue?vue&type=script&lang=js"

import "./EmployeeDetail.vue?vue&type=style&index=0&id=7b78cfce&lang=css"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__